import React from 'react';
import * as _360interface from '../../interface';

function textureFileList(textures) {
  if (typeof textures !== 'string') {
    return textures || [];
  }
  try {
    return JSON.parse(textures);
  } catch {
    return [];
  }
}

class Model extends React.PureComponent {
  componentDidMount() {
    this.loadPlaces(this.props.models);
  }

  componentDidUpdate(prevProps) {
    const {
      models,
      placeIds = [],
      uuids,
      pngTransparencyEnabled,
      textures,
      settings,
    } = this.props;
    if (prevProps.pngTransparencyEnabled !== pngTransparencyEnabled) {
      models.forEach((place) => {
        _360interface.replacePlacedModel(place, {
          pngTransparency: Boolean(pngTransparencyEnabled),
        });
      });
    }
    if (prevProps.models.length < models.length) {
      const added = models.slice(prevProps.models.length);
      this.loadPlaces(added);
    }
    if (prevProps.placeIds.length > placeIds.length) {
      const removedId = prevProps.placeIds.find((id) => placeIds.indexOf(id) < 0);
      if (removedId != null) {
        _360interface.removePlacedModel(removedId);
      }
    }
    const modelsIdentityChanged =
      prevProps.models.length !== models.length ||
      prevProps.models.some((place, index) => place !== models[index]);
    if (modelsIdentityChanged) {
      models.forEach((place) => {
        const previous = prevProps.models.find((item) => item.id === place.id);
        if (!previous) {
          return;
        }
        const clipChanged =
          _360interface.isGroundClippingEnabled(
            previous.ground_plane_clipping_enabled
          ) !==
          _360interface.isGroundClippingEnabled(
            place.ground_plane_clipping_enabled
          );
        if (clipChanged) {
          _360interface.replacePlacedModel(place);
        }
        if (previous.hover_color !== place.hover_color) {
          _360interface.setPlacedModelHighlightColor(
            place.id,
            place.hover_color
          );
        }
      });
    }
    if (
      prevProps.uuids !== uuids ||
      prevProps.textures !== textures ||
      prevProps.settings?.lod !== settings?.lod
    ) {
      this.configureLod();
    }
  }

  componentWillUnmount() {
    this.props.placeIds?.forEach((id) => {
      _360interface.removePlacedModel(id);
    });
  }

  configureLod() {
    const { modelBlob, textures, settings, mapId, modelId } = this.props;
    _360interface.configureModelLod({
      sourceUrl: modelBlob,
      lod: settings?.lod,
      textureFiles: textureFileList(textures),
      mapId,
      modelId,
    });
  }

  async loadPlaces(places) {
    this.configureLod();
    const { modelBlob, pngTransparencyEnabled, saveUUIDs, onPlaceClick } =
      this.props;
    const results = await Promise.allSettled(
      places.filter(Boolean).map(async (place) => {
        const handle = await _360interface.addPlacedModel(place, modelBlob, {
          pngTransparency: Boolean(pngTransparencyEnabled),
          onClick: () => onPlaceClick?.(place.id),
        });
        return handle ? [place.id, handle.id] : null;
      })
    );
    const uuids = {};
    results.forEach((result) => {
      if (result.status === 'fulfilled' && result.value) {
        const [id, uuid] = result.value;
        uuids[id] = uuid;
      }
    });
    if (Object.keys(uuids).length > 0) {
      saveUUIDs(uuids);
    }
  }

  render() {
    return null;
  }
}

export default Model;
